export const formatPhoneValidation = ({phone}) => ({
  countryCode: phone?.countryCode,
  validPhone: phone?.number,
  phoneType: phone?.type,
});
